// https://mycolor.space/?hex=%23EC008C&sub=1
let colors = {
  // primary: '#2196f3',
  // primaryDark: '#1769aa',
  // primaryLight: '#4dabf5',

  black: '#000',
  lightGrey: '#d3d3d3',
  veryLightGrey: '#f0f0f0',
  darkGrey: '#757575',
  red: '#f44336',
  lightRed: '#e57373',
  darkRed: '#d32f2f',
  green: '#4caf50',
  yellow: '#f6a939',

  primary: '#ff9801',
  primaryDark: '#df8809',
  primaryLight: '#f6a939',
  secondary: '#4caf50',
  secondaryDark: '#00796B',
  secondaryLight: '#B2DFDB',

  button: '',
  values: '',
  drawer: '',
  divider: 'rgba(0, 0, 0, 0.12)' // '#bcbbc1'
};

colors = {
  ...colors,
  button: colors.primary,
  values: colors.secondary,
  drawer: colors.primary
};

export default colors;
